const getters = {
  avatar: state => state.authentication.avatar,
  cachedViews: state => state.tagsView.cachedViews,
  device: state => state.app.device,
  domainID: state => state.authentication.domainID,
  language: state => state.app.language,
  name: state => state.authentication.name,
  permission_routers: state => state.permission.routes,
  permissions: state => state.authentication.permissions,
  addRouters: state => state.permission.addRouters,
  sidebar: state => state.app.sidebar,
  dateTimeFormat: state => state.app.dateTimeFormat,
  dateTimeFormatDayJS: state => state.app.dateTimeFormat.replace(/(dd)/g, 'DD').replace(/(yyyy)/g, 'YYYY'),
  size: state => state.app.size,
  dateFormat: state => state.app.dateFormat,
  visitedViews: state => state.tagsView.visitedViews,
  errorLogs: state => state.errorLog.logs,
  token: state => state.authentication.token,
  roles: state => state.authentication.roles,
  setting: state => state.authentication.setting,
  status: state => state.authentication.status,
  timeFormat: state => state.app.timeFormat,
  userId: state => state.authentication.userId,
  pageVersion: state => state.app.pageVersion,
  multilingual: state => state.app.multilingual,
  validationErrorInputPrefix: state => state.app.validationErrorInputPrefix
};
export default getters;
